import HeaderSecond from '../HeaderSecond'
import React, { useState, useEffect, useRef } from 'react';
import { Link, useNavigate, useParams, useLocation } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import BreadcrumbBg from '../img/banner/breadcrumb-bg.jpg';
import registerationsImg from '../../src/img/other/agenda.png';
import { useDownloadExcel } from 'react-export-table-to-excel';
import axios from '../axios';
import Pagination from '../Components/Pagination'
import LoaderImg from '../img/logo/running.gif';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';

const TicketRegisteredUsers = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const { state } = location;
    const [EventName, setEventName] = useState("");
   
    const UserId = state ? state.user_id : 0;
    const EventBookingId = state ? state.EventBookingId : 0;
    const [ApiCall, setApiCall] = useState(false);
    const [AttendeeData, setAttendeeData] = useState([]);
    const [CouponCode, setCouponCode] = useState("");
    const [Loader, setLoader] = useState(false);
    
    // console.log(MassegeContent);
    var copyText = window.location.origin + process.env.PUBLIC_URL;
    const formattedEventName = EventName.replace(/\s/g, '_');
    const EventLink = copyText + "/e/" + formattedEventName;
//    console.log(EventLink);

    var url = new URL(window.location.href);
    // console.log(url);
    const page = url.searchParams.get('PageNo') || 1
    const limit = url.searchParams.get('Limit') || 30
    const [TotalRecord, setTotalRecord] = useState("");
    // console.log(page);
    const HandleClear = (e) => {
        e.preventDefault();
        setCouponCode(""); 
        setApiCall(true);
        navigate('/ticket_registered_users')
    }

    useEffect(() => {
        if ((ApiCall || page)) {
            setLoader(true);
            axios.post("ticket_registered_users", {
                "coupon_code" : CouponCode,
                "limit": limit,
                "page": page,
            })
                .then((response) => {
                    // console.log(response.data.data.participant_details)
                    if (response.status === 200) {
                        setLoader(false);
                        setAttendeeData(response.data.data.participant_details)
                        setApiCall(false);
                    }
                    setApiCall(false)
                })
                .catch((error) => {
                    console.log(error)
                    setLoader(false);
                })
        }

    }, [ApiCall, page])
    // console.log(EventId);

    const handleSubmit = (e, type) => {
        e.preventDefault();
        setApiCall(true);
    }

    return (
        <>
          {Loader ? <div><div id='loader' style={{ backgroundImage: `url(${LoaderImg})` }}></div></div> : null}
        
            <ToastContainer theme="colored" />
            <HeaderSecond />
            <main className="main__content_wrapper">
                <section className="breadcrumb__section breadcrumb__bg" style={{ backgroundImage: `url(${BreadcrumbBg})` }} >
                    <div className="container">
                        <div className="row row-cols-1">
                            <div className="col">
                                <div className="breadcrumb__content">
                                    <h1 className="breadcrumb__content--title text-white mb-10">
                                        WVC Women's World Virtual Championship 2026
                                    </h1>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <div className='section--padding  pt-5'>
                    <div className='container'>
                        <div className="section__header checkout__section--header d-flex align-items-center justify-content-between mb-4">
                            <h2 className="section__header--title h3">Referral List</h2>
                            <div className="event-visibility hand_cursor">
                                {/* <div className="visibility gap-1 ">
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        height={20}
                                        viewBox="0 -960 960 960"
                                        width={20}
                                    >
                                        <path d="m313-440 224 224-57 56-320-320 320-320 57 56-224 224h487v80H313Z" />
                                    </svg>
                                    Back
                                </div> */}
                            </div>
                        </div>

                        <div className='dashboard-card border-radius-10 mb-6 p-4'>
                            <div className="row my-2">
                                <div className="col-sm-6 d-flex align-items-center gap-2">
                                <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px"><path d="M784-120 532-372q-30 24-69 38t-83 14q-109 0-184.5-75.5T120-580q0-109 75.5-184.5T380-840q109 0 184.5 75.5T640-580q0 44-14 83t-38 69l252 252-56 56ZM380-400q75 0 127.5-52.5T560-580q0-75-52.5-127.5T380-760q-75 0-127.5 52.5T200-580q0 75 52.5 127.5T380-400Z" /></svg>
                                <p className='h4'>Search Filter</p>
                                </div>
                                <div className="col-sm-6 d-flex align-items-center justify-content-end gap-2">
                               
                                </div>
                            </div>
                            <div className='row my-2 align-items-center'>
                                <div className='col-sm-3 my-2'>
                                    <div className="form-floating">
                                        <input
                                            type="text"
                                            className="form-control"
                                            placeholder=""
                                            value={CouponCode}
                                            onChange={(e) => {
                                                setCouponCode(e.target.value);
                                            }}
                                        />
                                        <label>Coupon Code </label>
                                    </div>
                                </div>
                                <div className='col-sm-1 my-2'>
                                    
                                    <p className="account__login--btn primary__btn" onClick={(e) => {
                                            handleSubmit(e);
                                        }} style={{cursor: 'pointer', display:"flex", alignItems: "center"}}>
                                        Search</p>

                                </div>
                                <div className='col-sm-1 my-2'>
                                    { (CouponCode !== "")  ?
                                        <p className="account__login--btn secondary__btn" onClick={(e) => {
                                            HandleClear(e);
                                        }} style={{cursor: 'pointer', display:"flex", alignItems: "center"}}>
                                        Clear</p>
                                    : null  }
                                </div>
                            </div>
                        </div>

                        <div className='dashboard-card p-4 border-radius-10 '>
                            <div className='row'>
                                <div className='col-sm-12'>
                                    {/* ref={tableRef} */}
                                    {/* {console.log(AttendeeData)} */}
                                    <table className="table table-hover">
                                        {
                                            AttendeeData && AttendeeData.length > 0 ?
                                                <>
                                                    <thead className="thead-dark">
                                                        <tr>
                                                            <th scope="col">Sr. No.</th>
                                                            <th scope="col">Full Name</th>
                                                            {/* <th scope="col">Email Id</th> */}
                                                            <th scope="col">Ticket Name</th>
                                                            <th scope="col">Booking Date</th>
                                                            <th scope="col">Transaction ID</th>
                                                            {/* <th scope="col">Ticket Price</th> */}
                                                            <th scope="col">Coupon Code</th>
                                                            {/* <th scope="col">Total Amount</th> */}
                                                            <th scope="col">Transaction Status</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {/* {console.log(AttendeeData)} */}
                                                        {AttendeeData.map((user, index) => {
                                                            
                                                               const no = page !== 1 ? ((page * limit - limit) + parseFloat(index+1)) : index + 1;   
                                                            return (
                                                                <tr key={index}>
                                                                   
                                                                    <th scope="row" className='text-center'>{no}</th>
                                                                   
                                                                    <td>{user.full_name}</td>
                                                                    {/* <td>{user.email}</td> */}
                                                                    <td>{user.TicketName}</td>
                                                                    <td>{user.booking_date}</td>
                                                                    <td>{user.transaction_id}</td>
                                                                    {/* <td>{'₹ '+parseFloat(user.ticket_amount).toFixed(2)}</td> */}
                                                                    <td>{user.discount_code ? user.discount_code : '-'}</td>
                                                                    {/* <td>{'₹ '+parseFloat(user.final_ticket_price).toFixed(2)}</td> */}
                                                                    <td>Success</td>
                                                                </tr>
                                                            );
                                                        })}
                                                    </tbody>
                                                </>
                                                :
                                                <><p>No Referral List Found</p></>
                                        }
                                    </table>
                                </div>
                            </div>

                            <div className='row'>
                                <div className='col-sm-12'>
                                
                                {/* {
                                    TotalRecord > 0 ?
                                    <Pagination
                                        records={AttendeeData.length}
                                        link={"event_netsale"}
                                        SelectedPage={page}
                                        search={"&event_id=" + EventId + "&user_id=" + UserId + "&EventBookingId=0&participant_name=" + ParticipantName + "&reg_id=" + RegistrationID + "&mobile_number=" + MobileNumber + "&email=" + Email + "&ticket_id=" + Ticket + "&from_date=" + FromDate + "&to_date=" + ToDate + "&TransactionStatus=" + TransactionStatus + "&TransactionID=" + TransactionID + "&coupon_used_flag=0"}
                                        NoOfRecords={TotalRecord}
                                    /> : null
                                } */}

                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </main>
        </>
    )
}

export default TicketRegisteredUsers